import * as React from 'react';
import { Helmet } from './meta';
import useCategory from '../hooks/useCategory';
import { getCanonicalBaseUrl, getLanguageId } from '../utils/globals';

const CategorySchema = () => {
  const category = useCategory();
  if (!category) return null;

  const url = `${getCanonicalBaseUrl()}/${getLanguageId()}/categories/${
    category.slug
  }`;

  return (
    <Helmet>
      <link rel="canonical" href={url} />
      <meta property="og:url" content={url}></meta>
    </Helmet>
  );
};

export default CategorySchema;
